import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../../wires/Identifiers'
import container from '../../../wires/Bootstrapper'

import { TTModalProps } from '../../shared/TTModalProps'
import { IUtenteBackofficeService } from '../../../services/UtenteBackofficeService'
import { RuoloClienteInputModel } from '../../../models/UtenteModels'
import { UtenteParams } from './../UtenteParams'
import { ModalContentClienteRole } from './ModalContentClienteRole'

export class ModalClienteRoleBackofficeComp extends React.Component<RouteComponentProps<UtenteParams> & TTModalProps, any> {

    service: IUtenteBackofficeService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.UTENTE_BACKOFFICE_SERVICE)
    }

    load = async () => {
        return this.service.RenderAssociaCliente()
    }

    onSave = async (model: RuoloClienteInputModel) => {
        let resp = await this.service.AssociaCliente(model)
        if (resp.IsValid == true) {
            this.props.closeModal()
            this.props.do()
        }
    }

    render() {
        return (
            <ModalContentClienteRole title="Seleziona il ruolo da associare"
                                     hasCliente={false}
                                     hasUfficio={true}
                                     onLoad={this.load} 
                                     onSave={this.onSave}
                visible={this.props.visible} closeModal={this.props.closeModal} />
        )
    }
}

export const ModalClienteRoleBackoffice = withRouter(ModalClienteRoleBackofficeComp)